interface FAQItem {
  question: string;
  answer: string;
}

export const FAQS: FAQItem[] = [
  {
    question: "What is CDTM Valencia Hacks?",
    answer:
      "CDTM Valencia Hacks is a intensive day hackathon, celebrated the 21st November (9:00 AM - 8:00 PM), where students come together to build innovative solutions. It's an opportunity to learn, connect, and turn ideas into reality while competing for exciting prizes.",
  },
  {
    question: "Who can participate?",
    answer:
      "Students from all universities and disciplines are welcome to participate. Whether you're a programmer, designer, or business student, there's a place for you at CDTM Valencia Hacks!",
  },
  {
    question: "Do I need to know how to code?",
    answer:
      "Not necessarily, but it can be very helpful to know how to code! We still welcome participants with diverse skill sets. Teams benefit from having members with different backgrounds, including business development, design, and project management.",
  },
  {
    question: "How much does it cost?",
    answer:
      "CDTM Valencia Hacks is completely free for all accepted participants. We provide meals, snacks, and beverages throughout the event, as well as a comfortable building space and mentorship.",
  },
  {
    question: "How do teams work?",
    answer:
      "Teams consist of 5 members. Staff will make sure teams are interdisciplinary. However, you can submit your preferred teammates and we will do our best to include them.",
  },
  {
    question: "What should I bring?",
    answer:
      "Bring your laptop, charger, and any other devices you might need. We'll provide the rest!",
  },
  {
    question: "Will there be food and drinks?",
    answer:
      "Absolutely! We provide a catering service for 80 people at the event.",
  },
  {
    question: "What kind of support is available during the hackathon?",
    answer:
      "We provide technical mentors, workshops, and access to various APIs and tools like Notion, Lovable and ElevenLabs. Our experienced mentors from industry partners will be available to help you with technical challenges and project development.",
  },
  {
    question: "How do I register for the hackathon?",
    answer:
      "You can register for the hackathon by filling out the registration form. You will have time until 23:59 to register on 13th November.",
  },
  {
    question: "Do I have to work on a case or learn before the hackathon?",
    answer:
      "No, you don't have to prepare anything for the hackathon. You will have time during the hackathon to build your project, however when selected we will share resources to help you make the most out of it.",
  },
  {
    question: "What criteria do you use to select participants?",
    answer:
      "We will select participants based on their education, experience level and previous projects. We will also start sending confirmations before applications deadline, therefore early applicants have higher chances of getting accepted.",
  },
  {
    question: "What if I don't have a team?",
    answer:
      "You will be matched with a team at the hackathon.",
  },
  {
    question: "What is the acceptance rate?",
    answer:
      "The acceptance rate is 50% since we accept 60 people and currently there are 120 applications.",
  },
  {
    question:"How can I apply to CDTM Valencia course recognised by UV & UPV?",
    answer:"In order to be notified to apply to CDTM Valencia free course, you can subscribe to our newsletter after the hackathon is over."
  }
];
